import { Box, Button, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, useCallback } from 'react';

import { UI } from '../../../../constants';
import { TLocalesKeys as K } from '../../../../types';
import { useUserAction } from '../../../common/hooks/useUserAction';
import { ILoginSelector } from '../../../common/messageCreators';
import { useLogin } from '../../hooks/useLogin';
import { MessageBubble } from '../MessageBubble';
import { MessageItem } from '../MessageItem';

export const LoginSelector: FC<ILoginSelector> = ({ id }) => {
  const { t } = useTranslation();
  const loginHandler = useLogin();
  const emit = useUserAction(UI.CANT_LOGIN_CLICKED);

  const cantLoginClick = useCallback(() => {
    emit({});
  }, [emit]);

  return (
    <MessageItem id={id}>
      <MessageBubble>
        <Box direction="vertical" gap="SP3" padding="SP1 0">
          <Text weight="bold">{t<K>('login_message')}</Text>
          <Box gap="SP1">
            <Button onClick={loginHandler}>{t<K>('login_btn_label')}</Button>
            <Button priority="secondary" dataHook="cant_login" onClick={cantLoginClick}>
              {t<K>('login_btn_no_login')}
            </Button>
          </Box>{' '}
        </Box>
      </MessageBubble>
    </MessageItem>
  );
};
